import { Flag, FolderCheck, FolderPlus } from "lucide-react"

import { FrontendTriggerDefinition } from "@/components/automations/types"

export const projectTriggers: FrontendTriggerDefinition[] = [
  {
    key: "trigger__project_created",
    label: "Project created",
    description: "Triggers when a new project is started",
    icon: FolderPlus,
    providesSubjects: ["project", "household"],
    inputFields: [
      {
        key: "project_template_ids",
        label: "Project type",
        inputType: "multi_select",
        required: true,
        options: "dynamic_project_templates",
      },
    ],
  },
  {
    key: "trigger__project_milestone_changed",
    label: "Milestone changed",
    description: "Triggers when a project moves into a milestone",
    icon: Flag,
    providesSubjects: ["project", "household"],
    inputFields: [
      {
        key: "project_template_ids",
        label: "Project type",
        inputType: "multi_select",
        required: true,
        options: "dynamic_project_templates",
      },
      {
        key: "project_milestone_ids",
        label: "Milestone entered",
        inputType: "multi_select",
        required: true,
        options: "dynamic_project_milestones",
      },
    ],
  },
  {
    key: "trigger__project_completed",
    label: "Project completed",
    description: "Triggers when a project is completed",
    icon: FolderCheck,
    providesSubjects: ["project", "household"],
    inputFields: [
      {
        key: "project_template_ids",
        label: "Project type",
        inputType: "multi_select",
        required: true,
        options: "dynamic_project_templates",
      },
    ],
  },
]
